import { HStack, VStack, Button, Text, Popover, PopoverContent, PopoverTrigger } from '@cad-arc';
import { EventSearchRow } from '@mark43/cad-api';

export function EventSearchResultsUnitsCell({
    eventSearchRow,
}: {
    eventSearchRow: EventSearchRow;
}) {
    const truncatedBackupUnitCallSigns = eventSearchRow.backupUnitCallSigns.slice(0, 4);
    const overflowBackupUnitCallSigns = eventSearchRow.backupUnitCallSigns.slice(4);
    return (
        <VStack align="left">
            <Text style={{ whiteSpace: 'normal', width: '188px' }}>
                {eventSearchRow.primaryUnitCallSignAndMembers}
            </Text>
            {eventSearchRow.backupUnitCallSigns.length > 0 ? (
                <HStack>
                    <Text color="tertiary">Add&apos;l:</Text>
                    <Text>{truncatedBackupUnitCallSigns.join(', ')}</Text>
                    {overflowBackupUnitCallSigns.length > 0 && (
                        <OverflowCallSignsPopover callSigns={overflowBackupUnitCallSigns} />
                    )}
                </HStack>
            ) : undefined}
        </VStack>
    );
}

function OverflowCallSignsPopover({ callSigns }: { callSigns: string[] }) {
    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button variant="ghost">{` +${callSigns.length}`}</Button>
            </PopoverTrigger>
            <PopoverContent style={{ maxWidth: '300px' }}>{callSigns.join(', ')}</PopoverContent>
        </Popover>
    );
}
